import {
    FormControlLabel,
    Table,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Tooltip,
    Typography,
    Grid,
    Switch,
    TableBody,
    Paper,
    
} from "@material-ui/core";
import { useEffect, useState } from "react";
import IconEstado from "../../../autorizaciones/UI/IconEstado";
import { useDispatch, useSelector } from "react-redux";
import { getConsumosAfiliadosDisca } from "../../../../actions/discapacidad/discapacidadActions";

const optionsfecha = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
const TabsDiscapacidad = (props) => {
    const dispatch = useDispatch();
    const { consumosAfiliado: items } = useSelector((state) => state.discapacidad);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [dense, setDense] = useState(true);

    //const [orderBy, setOrderBy] = useState(null);
    //const [order, setOrder] = useState('asc'); // 'asc' o 'desc'
    const orderBy = null;
    const order = 'asc'; // 'asc' o 'desc'

    useEffect(() => {
        dispatch(getConsumosAfiliadosDisca(props.afiliado.id_afiliado));
    }, [dispatch]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <>
            {Array.isArray(items) &&
                items?.length > 0 ? (
                <TableContainer component={Paper} style={{ overflowX: "auto" }}>
                    <Table size={dense ? "small" : "medium"}>
                        <TableHead>
                            <TableRow>
                                <Tooltip title="Reordenar (asc/desc)" arrow>
                                    <TableCell
                                        align="left"
                                        sortDirection={orderBy === 'idSolicitud' ? order : false}
                                    >
                                        N° Orden {('idSolicitud')}
                                    </TableCell>
                                </Tooltip>
                                <TableCell>Estado</TableCell>
                                <TableCell>Practica</TableCell>
                                <TableCell>Cant.</TableCell>
                                <TableCell>Diagnostico</TableCell>
                                <TableCell>Tipo</TableCell>
                                <TableCell>SubTipo</TableCell>
                                <TableCell>Prestador</TableCell>
                                <TableCell>Fecha Desde</TableCell>
                                <TableCell>Fecha Hasta</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {items
                                ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((solicitud) => {
                                    return (
                                        <TableRow key={solicitud?.keySp}>
                                            <TableCell>{solicitud?.idSolicitud}</TableCell>
                                            <TableCell>
                                                <IconEstado
                                                    useColorTable={true}
                                                    texto={solicitud?.letra}
                                                    backgroundColor={solicitud?.color}
                                                    descripcion={solicitud?.descEstado}
                                                />
                                            </TableCell>
                                            <TableCell>{solicitud?.descPractica}</TableCell>
                                            <TableCell>{solicitud?.cantPractica}</TableCell>
                                            <TableCell>{solicitud?.diagnosticos.map((diagnostico)=>{
                                                  return(
                                                    <div style={{display:'block'}}>
                                                    <ul><li>{diagnostico.diagnostico.descripcion}</li></ul>
                                                    </div>
                                                  )  
                                            })}</TableCell>
                                            <TableCell>{solicitud?.tipoSolicitud}</TableCell>
                                            <TableCell>{solicitud?.subtipoSolicitud}</TableCell>
                                            <TableCell>{solicitud?.efector}</TableCell>
                                            <TableCell>
                                                {new Date(solicitud?.fechaDesde).toLocaleString(
                                                    "es",
                                                    optionsfecha
                                                )}
                                            </TableCell>
                                            <TableCell>
                                                {new Date(solicitud?.fechaHasta).toLocaleString(
                                                    "es",
                                                    optionsfecha
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </TableContainer>
            ) : (
                <Typography style={{ fontStyle: "italic", fontSize: "1.1rem" }}>
                    No hay datos
                </Typography>
            )}
            {items?.length > 0 && (
                <Grid item xs={12}>
                    <TablePagination
              style={{ backgroundColor: "white" }}
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={items.length}
              rowsPerPage={rowsPerPage}
              labelRowsPerPage="Registros por página"
              page={page}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
                    <FormControlLabel
                        control={
                            <Switch
                                checked={dense}
                                onChange={(e) => setDense(e.target.checked)}
                            />
                        }
                        label="Tamaño compacto"
                    />
                </Grid>
            )}
        </>
    );
};
export default TabsDiscapacidad; 